import { Link, useSearchParams } from "react-router-dom";
import { XCircle, ArrowLeft, RefreshCw } from "lucide-react";
import { Button } from "../components/ui/button";

const PaymentFailurePage = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("order_id");

  return (
    <div className="min-h-screen bg-slate-50 font-['DM_Sans']">
      {/* Header */}
      <header className="bg-white border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center gap-2">
              <img src="/logo-hostprotect.png" alt="HostProtect" className="h-9 w-auto" />
            </Link>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="py-16 sm:py-24">
        <div className="max-w-lg mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl border border-slate-200 shadow-lg p-8 text-center" data-testid="payment-failure-card">
            <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <XCircle className="w-10 h-10 text-red-600" />
            </div>
            
            <h1 className="text-2xl font-bold text-[#19294C] font-['Outfit']" data-testid="failure-title">
              Paiement annulé
            </h1>
            
            <p className="mt-4 text-slate-600">
              Votre paiement a été annulé ou n'a pas pu être traité. 
              Aucun montant n'a été débité de votre compte.
            </p>

            <div className="mt-8 space-y-3">
              <Link to="/checkout">
                <Button 
                  className="w-full bg-[#00B8E4] hover:bg-[#00a5ce] text-white"
                  data-testid="retry-payment-btn"
                >
                  <RefreshCw className="w-4 h-4 mr-2" />
                  Réessayer le paiement
                </Button>
              </Link>
              
              <Link to="/dashboard">
                <Button 
                  variant="outline" 
                  className="w-full border-slate-300 text-slate-700 hover:bg-slate-50"
                  data-testid="back-to-dashboard-btn"
                >
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Retour au tableau de bord
                </Button>
              </Link>
            </div>

            <div className="mt-8 p-4 bg-slate-50 rounded-lg">
              <p className="text-sm text-slate-600">
                <strong>Besoin d'aide ?</strong><br />
                Si le problème persiste, contactez notre support à{" "}
                <a href="mailto:support@hostprotect.io" className="text-[#00B8E4] hover:underline">
                  support@hostprotect.io
                </a>
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PaymentFailurePage;
